import React, { useEffect, useState } from 'react'
import StatusActive from '../Status';
import WaterMeter from '../Charts/WaterMeter';

const WaterMeterChart = ({ dataSource }) => {

    const [valueData, setValueData] = useState(0);
    const [maxValue, setMaxValue] = useState(120);
    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (dataSource) {
                    const response = dataSource;
                    const convertValue = parseFloat(response.Value1);
                    setValueData(convertValue);
                    setData([response]);
                    setMaxValue(response.MaxValue1);
                    // if (convertValue > maxValue) {
                    //     setMaxValue(Math.ceil(convertValue / 10) * 10);
                    // }
                }
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();

    }, [dataSource, maxValue]);

    return (
        <div className="relative flex flex-col justify-center items-center w-full p-4 rounded-lg gap-2">
            <StatusActive setData={data} />
            <div className="relative flex">

                <div className="absolute bottom-0 left-20 mb-2">
                    <h2 className="font-semibold text-2xl">{valueData ? valueData : 0}cm</h2>
                </div>

                <WaterMeter
                    theme="light"
                    value={valueData}
                    max={maxValue}
                    // format="°C"
                    // size="normal"
                    width={window.innerWidth > 768 ? 10 : 8}
                    height={window.innerWidth > 768 ? 200 : 190}
                    steps="5"
                />

            </div>
        </div>
    )
}

export default WaterMeterChart